import { Controller } from '@hotwired/stimulus'

// Mobile top-navigation drawer. Put `data-controller="mobile-nav"` on the
// <nav>, mark the collapsible panel with `data-mobile-nav-target="menu"` and
// toggle it from the hamburger button with `data-action="mobile-nav#toggle"`.
// Optionally mark the hamburger's open/close icons as `openIcon`/`closeIcon`
// targets so they swap while the drawer is open.
export default class extends Controller {
  static targets = ['menu', 'openIcon', 'closeIcon']

  connect() {
    this.isOpen = false
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    this.handleResize = this.handleResize.bind(this)
  }

  disconnect() {
    this.close()
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    if (this.isOpen) return
    this.isOpen = true
    this.menuTarget.classList.remove('hidden')
    if (this.hasOpenIconTarget) this.openIconTarget.classList.add('hidden')
    if (this.hasCloseIconTarget) this.closeIconTarget.classList.remove('hidden')
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('keydown', this.handleKeydown)
    window.addEventListener('resize', this.handleResize)
  }

  close() {
    if (!this.isOpen) return
    this.isOpen = false
    this.menuTarget.classList.add('hidden')
    if (this.hasOpenIconTarget) this.openIconTarget.classList.remove('hidden')
    if (this.hasCloseIconTarget) this.closeIconTarget.classList.add('hidden')
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('resize', this.handleResize)
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close()
  }

  handleResize() {
    // Auto-close the drawer when the viewport grows past the mobile breakpoint.
    if (window.innerWidth >= 768) this.close()
  }
}
